export const IntroducedByList = [
  { value: "FR", text: 'دوست' },
  { value: "IN", text: 'اینترنت' },





]

const IntroducedBySetter = (val) => {

  let value = null
  IntroducedByList.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default IntroducedBySetter;
